<template lang="pug">
section.main(:class="collapsed ? 'wide' : 'narrow'")
  Header(ref="header")
  Menu
  section.page.job(v-if="$auth.isAuthenticated && currentUser")
    b-navbar.title
      b-navbar-brand
        i.icon.fas.fa-file-alt
        span {{ page.title }}
      b-navbar-nav.ml-auto
        b-nav-item
          b-button(variant="link",@click="onClose()") 一覧へ戻る

    section.body(ref="body")
      ValidationObserver(slim,ref="observer")
        b-form.form(ref="form",:data-mode="mode",@submit.prevent)
          b-container.pb-3(fluid)
            b-row.pt-3
              b-col(cols=6)
                b-form-group(label="ポジション名",label-for="input-name",description="",required)
                  ValidationProvider(rules="required",name="ポジション名",v-slot="{ errors }")
                    b-form-input#input-name(ref="input-name",v-model="datum.name",type="text",required,placeholder="ポジション名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
                b-form-group(label="応募状態",label-for="input-enable",required)
                  ValidationProvider(rules="required",name="応募受付・停止",v-slot="{ errors }")
                    b-form-radio-group#input-enable(ref="input-enable",v-model="datum.enable",@input="validateInput",:disabled="!editable",:readonly="!editable")
                      template(v-for="(obj, index) in options.enable")
                        b-form-radio.ml-2.mt-2(required,:value="obj.value")
                          span {{obj.text}}
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col(cols=6)
                b-form-group(label="職種",label-for="input-occupation",description="",required)
                  ValidationProvider(rules="required",name="職種",v-slot="{ errors }")
                    b-form-select#input-occupation(v-model="datum.occupation",:options="options.occupation",required,placeholder="職種を選択してください",@change="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
                b-form-group(label="役職",label-for="input-position",description="",required)
                  ValidationProvider(rules="required",name="役職",v-slot="{ errors }")
                    b-form-select#input-position(v-model="datum.position",:options="options.position",required,placeholder="役職を選択してください",@change="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col(cols=6)
                b-form-group(label="雇用形態",label-for="input-employment",description="",required)
                  ValidationProvider(rules="required",name="雇用形態",v-slot="{ errors }")
                    b-form-select#input-employment(v-model="datum.employment",:options="options.employment",required,placeholder="雇用形態を選択してください",@change="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col(cols=12)
                b-form-group(label="業務内容",label-for="input-description",description="",required)
                  ValidationProvider(rules="required|max:10000",name="業務内容",v-slot="{ errors }")
                    b-form-textarea#input-description(v-model="datum.description",type="text",max-rows="20",placeholder="業務内容を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col.salary(cols=6)
                .form-group(required="required")
                  label(for="input-salary_min") 年収
                  .form-inline(v-if="datum.salary")
                    b-form-group.mb-2(label="",label-for="input-salary_min",description="")
                      ValidationProvider(rules="required|min_value:100|max_value:99999",name="年収（下限）",v-slot="{ errors }")
                        b-input-group
                          b-form-input#input-salary_min(ref="input-salary_min",v-model="datum.salary.min",type="number",placeholder="",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          b-input-group-append 万円
                        .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                    .separator.mx-2 〜
                    b-form-group.mb-2(label="",label-for="input-salary_max",description="")
                      ValidationProvider(rules="required|min_value:100|max_value:99999",name="年収（上限）",v-slot="{ errors }")
                        b-input-group
                          b-form-input#input-salary_max(ref="input-salary_max",v-model="datum.salary.max",type="number",placeholder="",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          b-input-group-append 万円
                        .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col.salary_note(cols=6)
                .form-group
                  b-form-group.mb-2(label="補足",label-for="input-salary_note",description="")
                    ValidationProvider(rules="max:4000",name="年収（補足）",v-slot="{ errors }")
                      b-form-textarea.input-salary_note(v-model="datum.salary.note",type="text",max-rows="10",placeholder="月給・固定残業代・賞与などを入力",@input="validateInput",:disabled="!editable",:readonly="!editable")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col.age(cols=6)
                .form-group(required="required")
                  label(for="input-age_min") 年齢
                  .form-inline(v-if="datum.age")
                    b-form-group.mb-2(label="",label-for="input-age_min",description="")
                      ValidationProvider(rules="required|min_value:10|max_value:110",name="年齢（下限）",v-slot="{ errors }")
                        b-input-group
                          b-form-input#input-age_min(v-model="datum.age.min",:options="options.age_min",type="number",placeholder="",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          b-input-group-append 才
                        .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                    .separator.mx-2 〜
                    b-form-group.mb-2(label="",label-for="input-age_max",description="")
                      ValidationProvider(rules="required|min_value:10|max_value:110",name="年齢（上限）",v-slot="{ errors }")
                        b-input-group
                          b-form-input#input-age_max(v-model="datum.age.max",:options="options.age_max",type="number",placeholder="",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          b-input-group-append 才
                        .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col.salary_note(cols=6)
                .form-group
                  b-form-group.mb-2(label="補足",label-for="input-age_note",description="")
                    ValidationProvider.box(rules="max:4000",name="年齢（補足）",v-slot="{ errors }")
                      b-form-textarea.input-age_note(v-model="datum.age.note",type="text",max-rows="10",placeholder="年齢補足",@input="validateInput",:disabled="!editable",:readonly="!editable")
                      .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col.recruitments(cols=6)
                b-form-group(label="採用人数",label-for="input-recruitments",description="",required)
                  ValidationProvider(rules="required",name="採用人数",v-slot="{ errors }")
                    b-form-input#input-recruitments(v-model="datum.recruitments",type="number",required,placeholder="採用人数を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col.dueDate(cols=12)
                .form-group(required="required")
                  label(for="input-launchDate") 採用期間
                  .form-inline
                    b-form-group(label="",label-for="input-launchDate",description="",required)
                      ValidationProvider(ref="launchDate",rules="required|date",name="採用開始日",v-slot="{ errors }")
                        b-input-group
                          b-form-input#input-launchDate(v-model="datum.launchDate",type="date",placeholder="年/月/日",pattern="((19|20)\d\d)[\/\-]([1-9]|0[1-9]|1[012])[\/\-]([1-9]|0[1-9]|[12][0-9]|3[01])",required,@input="validateInput",:disabled="!editable",:readonly="!editable")
                          //-b-input-group-append
                            //b-form-datepicker(v-model="datum.launchDate",button-only,locale="ja-JP",:date-format-options="{ year:'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow' }",placeholder="開始日を設定",@input="validateInput",:disabled="!editable",:readonly="!editable")
                        .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                    .separator.mx-2 〜
                    b-form-group(label="",label-for="input-dueDate",description="",required)
                      ValidationProvider(ref="dueDate",rules="required|date",name="採用期日",v-slot="{ errors }")
                        b-input-group
                          b-form-input#input-dueDate(v-model="datum.dueDate",type="date",placeholder="年/月/日",pattern="((19|20)\d\d)[\/\-]([1-9]|0[1-9]|1[012])[\/\-]([1-9]|0[1-9]|[12][0-9]|3[01])",required,@input="validateInput",:disabled="!editable",:readonly="!editable")
                          //-b-input-group-append
                            //b-form-datepicker(v-model="datum.dueDate",button-only,locale="ja-JP",:date-format-options="{ year:'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow' }",placeholder="期日を設定",@input="validateInput",:disabled="!editable",:readonly="!editable")
                        .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row(v-show="currentUser.role !== 'agent'")
              b-col
                b-form-group(label="採用責任者",label-for="input-managers",description="",required)
                  ValidationProvider(rules="",name="採用責任者",v-slot="{ errors }")
                    v-select#input-managers(ref="managers",v-model="selected.managers",multiple,:filterable="false",:options="options.manager",label="name",placeholder="採用責任者を指定してください",@input="validateInput",@search="onManagerSearch", :disabled="!editable",:readonly="!editable")
                      template(slot="no-options")
                        span type name to search Users...
                      template(slot="option",slot-scope="option")
                        .d-center
                          span {{ `${option && option.name ? option.name : ''}` }}
                      template(slot="selected-option",slot-scope="option")
                        .d-center.selected
                          span {{ `${option && option.name ? option.name : ''}` }}
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row(v-show="currentUser.role !== 'agent'")
              b-col
                b-form-group(label="採用担当者",label-for="input-recruiters",description="",required)
                  ValidationProvider(rules="",name="採用担当者",v-slot="{ errors }")
                    v-select#input-recruiters(ref="recruiters",v-model="selected.recruiters",multiple,:filterable="false",:options="options.recruiter",label="name",placeholder="採用担当者を指定してください",@input="validateInput",@search="onRecruiterSearch", :disabled="!editable",:readonly="!editable")
                      template(slot="no-options")
                        span type name to search Users...
                      template(slot="option",slot-scope="option")
                        .d-center
                          span {{ `${option && option.name ? option.name : ''}` }}
                      template(slot="selected-option",slot-scope="option")
                        .d-center.selected
                          span {{ `${option && option.name ? option.name : ''}` }}
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row(v-show="currentUser.role !== 'agent'")
              b-col
                b-form-group(label="選考担当者",label-for="input-staffs",description="",required)
                  ValidationProvider(rules="",name="選考担当者",v-slot="{ errors }")
                    v-select#input-staffs(ref="staffs",v-model="selected.staffs",multiple,:filterable="false",:options="options.staff",label="name",placeholder="選考担当者を指定してください",@input="validateInput",@search="onStaffSearch", :disabled="!editable",:readonly="!editable")
                      template(slot="no-options")
                        span type name to search Users...
                      template(slot="option",slot-scope="option")
                        .d-center
                          span {{ `${option && option.name ? option.name : ''}` }}
                      template(slot="selected-option",slot-scope="option")
                        .d-center.selected
                          span {{ `${option && option.name ? option.name : ''}` }}
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row(v-show="currentUser.role !== 'agent'")
              b-col
                b-form-group(label="エージェント",label-for="input-agents",description="")
                  ValidationProvider(rules="",name="エージェント",v-slot="{ errors }")
                    v-select#input-agents(ref="agents",v-model="selected.agents",multiple,:filterable="false",:options="options.agent",label="name",placeholder="エージェントを指定してください",@input="validateInput",@search="onAgentSearch", :disabled="!editable",:readonly="!editable")
                      template(slot="no-options")
                        span type name to search Users...
                      template(slot="option",slot-scope="option")
                        .d-center
                          span {{ `${option && option.name ? option.name : ''}` }}
                      template(slot="selected-option",slot-scope="option")
                        .d-center.selected
                          span {{ `${option && option.name ? option.name : ''}` }}
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

            b-row(v-show="currentUser.role !== 'agent'")
              b-col
                b-form-group(label="採用コンサルタント",label-for="input-consultants",description="")
                  ValidationProvider(rules="",name="採用コンサルタント",v-slot="{ errors }")
                    v-select#input-consultants(ref="consultants",v-model="selected.consultants",multiple,:filterable="false",:options="options.consultant",label="name",placeholder="採用コンサルタントを指定してください",@input="validateInput",@search="onConsultantSearch", :disabled="!editable",:readonly="!editable")
                      template(slot="no-options")
                        span type name to search Users...
                      template(slot="option",slot-scope="option")
                        .d-center
                          span {{ `${option && option.name ? option.name : ''}` }}
                      template(slot="selected-option",slot-scope="option")
                        .d-center.selected
                          span {{ `${option && option.name ? option.name : ''}` }}
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col.steps
                .form-group(required="required")
                  label(for="input-steps") 選考ステップ
                  p.small.text-dark(v-if="editable") ※ 選考ステップは「書類選考」ではじまり「面談」または「面接」で終わるようにしてください。
                  .form-inline
                    b-form-group.mb-2(v-for="(step, index) in datum.steps",:key="index",label="",:label-for="`input-step-code_${index + 1}`",description="",required)
                      ValidationProvider.box(rules="required",:name="`選考ステップ（${index + 1}行目）`",v-slot="{ errors }")
                        b-form-select.input-step-codes.mr-2(:id="`input-step-code_${index + 1}`",v-model="step.code",:options="options.step",required,placeholder="選考ステップを選択してください",@change="validateInput",:disabled="!editable",:readonly="!editable")
                        .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

                      b-button.removeSteps(variant="link",@click="removeSteps(index)",:disabled="!editable || (datum.steps && datum.steps.length <= 2)")
                        i.menu-icon.fas.fa-minus-circle

                  template(v-if="editable")
                    b-button.addSteps(variant="link",@click="addSteps()",:disabled="!editable || (datum.steps && datum.steps.length >= 10)")
                      i.menu-icon.fas.fa-plus-circle
                      span
                  template(v-else)
                    p

            b-row
              b-col.locations
                .form-group(required="required")
                  label(for="input-locations") 勤務地
                  .form-inline
                    b-form-group.mb-2(v-for="(location, index) in datum.locations",:key="index",label="",:label-for="`input-location_${index + 1}-prefecture`",description="",required)
                      ValidationProvider.box(rules="required",:name="`都道府県（${index + 1}行目）`",v-slot="{ errors }")
                        b-form-select.input-location-prefectures(:id="`input-location_${index + 1}-prefecture`",v-model="location.prefecture",:options="options.prefectures",@change="validateInput",:disabled="!editable",:readonly="!editable")
                        .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                      ValidationProvider.box(rules="required",:name="`名称（${index + 1}行目）`",v-slot="{ errors }")
                        b-form-input.input-location-names.ml-2(:id="`input-location_${index + 1}-name`",v-model="location.name",type="text",placeholder="名称を入力",@input="validateInput",:disabled="!editable",:readonly="!editable")
                        .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

                      b-button.removeLocations(variant="link",@click="removeLocations(index)",:disabled="!editable || (datum.locations && datum.locations.length <= 1)")
                        i.menu-icon.fas.fa-minus-circle

                  template(v-if="editable")
                    b-button.addLocations(variant="link",@click="addLocations()",:disabled="!editable || (datum.locations && datum.locations.length >= 100)")
                      i.menu-icon.fas.fa-plus-circle
                      span
                  template(v-else)
                    p

            b-row
              b-col(cols=12)
                b-form-group(label="応募資格・スキル（必須）",label-for="input-qualification",description="",required)
                  ValidationProvider(rules="required|max:10000",name="応募資格・スキル（必須）",v-slot="{ errors }")
                    b-form-textarea#input-qualification(v-model="datum.qualification",type="text",max-rows="20",placeholder="応募資格・スキル（必須）",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

            b-row
              b-col(cols=12)
                b-form-group(label="歓迎する資格・スキル",label-for="input-subQualification",description="")
                  ValidationProvider(rules="max:10000",name="歓迎する資格・スキル",v-slot="{ errors }")
                    b-form-textarea#input-subQualification(v-model="datum.subQualification",type="text",max-rows="30",placeholder="歓迎する資格・スキル",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

            b-row
              b-col.d-flex.justify-content-between
                .form-group.mb-0
                  label 参考URL
            b-row
              b-col.links
                b-card.mb-3(no-body,v-for="(link, index) in datum.links",:key="index")
                  b-card-title.position-absolute
                    b-button.removeLinks(variant="link",@click="removeLinks(index)",:disabled="!editable || (datum.links && datum.links.length <= 0)")
                      i.menu-icon.fas.fa-minus-circle
                  b-card-body.p-0
                    b-container.border.rounded(fluid)
                      b-row.mt-3
                        b-col(cols=4)
                          b-form-group(label="名称",:label-for="`input-link_${index + 1}-caption`",description="")
                            ValidationProvider(rules="",:name="`名称(${index + 1}行目)`",v-slot="{ errors }")
                              b-form-input.input-links-caption(:id="`input-link_${index + 1}-caption`",v-model="link.caption",@change="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                        b-col(cols=8)
                          b-form-group(label="URL",:label-for="`input-link_${index + 1}-url`",description="",required)
                            ValidationProvider(rules="required",:name="`URL${index + 1}行目）`",v-slot="{ errors }")
                              b-form-input.input-links-url(:id="`input-link_${index + 1}-url`",v-model="link.url",type="text",required,placeholder="URLを入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

                template(v-if="editable")
                  b-button.addLinks(variant="link",@click="addLinks()",:disabled="!editable || (datum.links && datum.links.length >= 10)")
                    i.align-middle.menu-icon.fas.fa-plus-circle
                    span.align-middle.ml-2 参考URLを追加
                template(v-else)
                  p

            b-row
              b-col
                .form-group.mb-0
                  label 添付ファイル
            b-row
              b-col
                b-container.border.rounded(fluid)
                  b-row.mt-3
                    b-col
                      template(v-if="editable")
                        b-form-group.uploadFile(label="求人票データなど（複数ファイル添付可能）",label-for="uploadFile",description="")
                          b-form-file#uploadFile(ref="uploadFile",v-model="uploadFile",browse-text="選択",placeholder="アップロードしたいファイルを選択してください",drop-placeholder="ファイルをドラッグ＆ドロップしてください。",@input="validateInput",:disabled="!editable",:readonly="!editable")
                        .uploadFiles
                          p.text-muted アップロードするファイル
                          .ml-2.mb-3.d-flex.flex-wrap
                            template(v-if="!uploadFiles || (uploadFiles && uploadFiles.length === 0)")
                              span.text-muted.no-uploadFiles なし
                            template(v-else)
                              .file.text-nowrap.mr-2(v-if="editable",v-for="(file, index) in uploadFiles",:key="index")
                                span.name {{file.name}}
                                b-button.removeUpdateFiles(variant="link",size="sm",@click="removeUploadFile(index)")
                                  i.menu-icon.fas.fa-minus-circle
                      .files(v-if="datum.Files && datum.Files.length > 0")
                        p.text-muted アップロード済みのファイル
                        .ml-2.mr-0.mb-3.d-flex.flex-wrap
                          span.file.mr-3.mb-2(v-for="(file, index) in datum.Files",:key="index",:class="file.remove ? 'remove' : ''")
                            b-button.p-0.text-left(variant="link",@click="download(`/jobs/${datum._id}/files/${file._id}.${file.extension}`, `${file.filename}`)")
                              span.text-wrap {{ file.filename }}
                            b-button.removeFiles(v-if="editable",variant="link",size="sm",@click="removeFile(index)")
                              i.menu-icon.fas.fa-minus-circle

            b-row.mt-3
              b-col
                b-form-group(label="補足情報・メモ",label-class="h6",label-for="input-note",description="")
                  ValidationProvider(rules="max:4000",name="補足情報・メモ",v-slot="{ errors }")
                    b-form-textarea#input-note(v-model="datum.note",type="text",max-rows="20",placeholder="補足情報・メモなどある場合、こちらに入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

        b-navbar.border-top.bottom-nav.bg-secondary
          b-navbar-nav
            b-nav-item
              b-button(variant="primary",v-show="mode === 'add' || mode === 'edit'",@click="onSave()",:disabled="!valid || !changed")
                span 保存
              b-button.ml-2(v-if="currentUser && currentUser.acl && currentUser.acl.jobs && currentUser.acl.jobs.patch && mode === 'edit'",variant="outline-primary",@click="onCopy()",:disabled="!currentUser.acl || !currentUser.acl.jobs || !currentUser.acl.jobs.patch || mode !== 'edit'")
                span.ml-1 このポジションをコピーして新規作成
          b-navbar-nav.ml-auto
            b-nav-item
              b-button(v-if="currentUser && currentUser.acl && currentUser.acl.jobs && currentUser.acl.jobs.delete && mode === 'edit'",variant="outline-danger",@click="onDelete()",:disabled="!currentUser.acl || !currentUser.acl.jobs || !currentUser.acl.jobs.delete || mode !== 'edit'")
                span 削除
</template>

<script>
import { isEqual } from 'lodash'

import QueryHash from 'query-hash'

import { getData, postData, patchData, deleteData, postFiles } from '../utils/api'

import { clone, difference, optionsStep, optionsPrefecture, optionsOccupation, optionsPosition, optionsEmployment, optionsJobEnable } from '../utils/libs'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.locale('ja')
dayjs.extend(localizedFormat)

const APP_DOMAIN = process.env.VUE_APP_APP_DOMAIN
let API_URL = process.env.VUE_APP_API_URL

const checkUrl = APP_DOMAIN.replace('*', '(.+?)')
if (window.location.origin.match(`https?://${checkUrl}`)) {
  API_URL = API_URL.replace('*', RegExp.$1)
}

const page = {
  id: 'job',
  title: 'ポジション情報'
}

export default {
  data () {
    return {
      API_URL: API_URL,
      mask: false,
      page: page,
      collapsed: true,
      currentUser: null,
      mode: null,
      editable: null,
      changed: false,
      valid: false,
      datum: {
        salary: {
          min: null,
          max: null
        },
        age: {
          min: null,
          max: null
        },
        enable: true
      },
      recentDatum: {},
      uploadFile: null,
      uploadFiles: [],
      options: {
        step: [],
        prefectures: [],
        occupation: [],
        position: [],
        employment: [],
        manager: [],
        recruiter: [],
        staff: [],
        agent: [],
        consultant: []
      },
      selected: {
        managers: {},
        recruiters: {},
        staffs: {},
        agents: {},
        consultants: {}
      }
    }
  },
  watch: {
    uploadFile (file) {
      if (file) {
        this.uploadFiles.push(file)

        this.$refs['uploadFile'].reset()
        // this.uploadFile = null

        this.validateInput()
      }
    }
  },
  mounted () {
    this.mode = 'add'
    this.editable = true
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.mode = 'show'
      this.editable = false
    }

    this.options.step = optionsStep()
    this.options.prefectures = optionsPrefecture()
    this.options.prefectures.unshift({
      value: null, text: '(未選択)'
    })

    this.options.enable = optionsJobEnable()

    this.options.occupation = optionsOccupation()
    this.options.position = optionsPosition()
    this.options.employment = optionsEmployment()

    this.changeMode()
  },
  methods: {
    async validateInput () {
      await this.$refs.observer.reset()
      this.valid = await this.$refs.observer.validate()

      if (this.valid) {
        if (this.datum.dueDate < this.datum.launchDate) {
          this.valid = false
          this.$refs.dueDate.errors.push('採用期日が正しくありません')
          this.$refs.launchDate.errors.push('採用開始日が正しくありません')
        }
      }

      if (this.datum.steps && this.datum.steps.length > 0) {
        let isEmptyStep = false
        this.datum.steps.forEach((step) => {
          if (!step.code) {
            isEmptyStep = true
          }
        })
        if (isEmptyStep && this.datum.steps.length > 2) {
          this.valid = false
        } else {
          let c = 0
          this.datum.steps.forEach((step) => {
            if (c === 0 && step.code !== '10') {
              this.valid = false
            } else if (c === this.datum.steps.length - 1 && (!step.code === '40' && !step.code === '50')) {
              this.valid = false
            }
            c++
          })
        }
      }

      if (this.datum.locations && this.datum.locations.length > 0) {
        let isEmptyLocation = false
        this.datum.locations.forEach((location) => {
          if (!location.prefecture || !location.name) {
            isEmptyLocation = true
          }
        })
        if (isEmptyLocation && this.datum.locations.length > 1) {
          this.valid = false
        }
      }

      if (this.selected.managers.length < 1) {
        this.valid = false
      }
      if (this.selected.recruiters.length < 1) {
        this.valid = false
      }
      if (this.selected.staffs.length < 1) {
        this.valid = false
      }
      /*
      if (this.selected.agents.length < 1) {
        this.valid = false
      }
      if (this.selected.consultants.length < 1) {
        this.valid = false
      }
      */

      let currentDatum = clone(this.datum)
      currentDatum.managers = clone(this.selected.managers)
      currentDatum.recruiters = clone(this.selected.recruiters)
      currentDatum.staffs = clone(this.selected.staffs)
      currentDatum.agents = clone(this.selected.agents)
      currentDatum.consultants = clone(this.selected.consultants)

      const diffDatum = difference(currentDatum, this.recentDatum)
      if (!isEqual({}, diffDatum)) {
        this.changed = true
      }

      if (!this.changed && this.uploadFiles.length > 0) {
        this.changed = true
      }

      if (!this.changed) {
        if (this.datum.Files) {
          const isRemoveFile = this.datum.Files.find((file) => {
            return file.remove
          })
          if (isRemoveFile) {
            this.changed = true
          }
        }
      }

      this.recentDatum = clone(this.datum)
      this.recentDatum.managers = clone(this.selected.managers)
      this.recentDatum.recruiters = clone(this.selected.recruiters)
      this.recentDatum.staffs = clone(this.selected.staffs)
      this.recentDatum.agents = clone(this.selected.agents)
      this.recentDatum.consultants = clone(this.selected.consultants)
    },
    changeMode () {
      if (this.mode === 'add' || this.mode === 'edit') {
        this.editable = true
      } else {
        this.editable = false
      }
      this.loadData()
    },
    async loadData () {
      this.mask = true

      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      let message = null

      this.datum = {}
      this.recentDatum = {}

      this.options.manager = []
      this.selected.managers = []
      this.options.recruiter = []
      this.selected.recruiters = []
      this.options.staff = []
      this.selected.staffs = []
      this.options.agent = []
      this.selected.agents = []
      this.options.consultant = []
      this.selected.consultants = []

      if (this.currentUser.role !== 'agent') {
        if (this.$refs.managers) {
          this.$refs.managers.search = ''
        }
        if (this.$refs.recruiters) {
          this.$refs.recruiters.search = ''
        }
        if (this.$refs.staffs) {
          this.$refs.staffs.search = ''
        }
        if (this.$refs.agents) {
          this.$refs.agents.search = ''
        }
        if (this.$refs.consultants) {
          this.$refs.consultants.search = ''
        }

        if (this.currentUser.role === 'manager') {
          this.selected.managers = [{
            _id: this.currentUser._id,
            name: this.currentUser.name
          }]
        } else if (this.currentUser.role === 'recruiter') {
          this.selected.recruiters = [{
            _id: this.currentUser._id,
            name: this.currentUser.name
          }]
        } else if (this.currentUser.role === 'staff') {
          this.selected.staffs = [{
            _id: this.currentUser._id,
            name: this.currentUser.name
          }]
        } else if (this.currentUser.role === 'agent') {
          this.selected.agents = [{
            _id: this.currentUser._id,
            name: this.currentUser.name
          }]
        } else if (this.currentUser.role === 'consultant') {
          this.selected.consultants = [{
            _id: this.currentUser._id,
            name: this.currentUser.name
          }]
        }

        let userQuery = new QueryHash()
        userQuery.add('filter', JSON.stringify({ role: { $in: ['master', 'manager'] } }))
        userQuery.add('fields', '_id,name')

        await getData(`/users?${userQuery.toQueryString()}`).then((data) => {
          if (data && data.length > 0) {
            this.options.manager = data
          }
        })

        userQuery = new QueryHash()
        userQuery.add('filter', JSON.stringify({ role: { $in: ['master', 'manager', 'recruiter'] } }))
        userQuery.add('fields', '_id,name')

        await getData(`/users?${userQuery.toQueryString()}`).then((data) => {
          if (data && data.length > 0) {
            this.options.recruiter = data
          }
        })

        userQuery = new QueryHash()
        userQuery.add('filter', JSON.stringify({ role: { $in: ['master', 'manager', 'recruiter', 'staff'] } }))
        userQuery.add('fields', '_id,name')

        await getData(`/users?${userQuery.toQueryString()}`).then((data) => {
          if (data && data.length > 0) {
            this.options.staff = data
          }
        })

        userQuery = new QueryHash()
        userQuery.add('filter', JSON.stringify({ role: { $in: ['agent'] } }))
        userQuery.add('fields', '_id,name')

        await getData(`/users?${userQuery.toQueryString()}`).then((data) => {
          if (data && data.length > 0) {
            this.options.agent = data
          }
        })

        userQuery = new QueryHash()
        userQuery.add('filter', JSON.stringify({ role: { $in: ['consultant'] } }))
        userQuery.add('fields', '_id,name')

        await getData(`/users?${userQuery.toQueryString()}`).then((data) => {
          if (data && data.length > 0) {
            this.options.consultant = data
          }
        })

        userQuery = new QueryHash()
        userQuery.add('filter', JSON.stringify({ role: { $in: ['agent'] } }))
        userQuery.add('fields', '_id,name')

        await getData(`/users?${userQuery.toQueryString()}`).then((data) => {
          if (data && data.length > 0) {
            this.options.agent = data
          }
        })

        userQuery = new QueryHash()
        userQuery.add('filter', JSON.stringify({ role: { $in: ['consultant'] } }))
        userQuery.add('fields', '_id,name')

        await getData(`/users?${userQuery.toQueryString()}`).then((data) => {
          if (data && data.length > 0) {
            this.options.consultant = data
          }
        })
      }

      this.uploadFiles = []

      if (this.mode === 'add') {
        if (!this.currentUser.acl || !this.currentUser.acl.jobs || !this.currentUser.acl.jobs.post) {
          this.handleLink(`/${this.$route.params.directory}/jobs`)
        }

        this.datum.salary = {
          min: null,
          max: null
        }

        this.datum.age = {
          min: null,
          max: null
        }

        this.datum.steps = [{ code: '10' }, { code: '50' }]

        this.datum.locations = [{
          prefecture: null,
          name: null
        }]

        this.datum.links = []

        this.recentDatum = clone(this.datum)

        if (this.currentUser.role === 'master' || this.currentUser.role === 'manager') {
          this.selected.managers = [{
            _id: this.currentUser._id,
            name: this.currentUser.name
          }]
        }

        if (this.currentUser.role !== 'agent') {
          await getData(`/users?filter={role:{$in:["agent"]}}&fields=_id,name`).then((data) => {
            if (data && data.length > 0) {
              this.selected.agents = data
            }
          })
          await getData(`/users?filter={role:{$in:["consultant"]}}&fields=_id,name`).then((data) => {
            if (data && data.length > 0) {
              this.selected.consultants = data
            }
          })
        }

        // copy
        if (this.$route.query && this.$route.query.copy) {
          await getData(`/jobs/${this.$route.query.copy}`).then((datum) => {
            if (datum) {
              this.datum = clone(datum)

              this.datum.name += 'のコピー'

              if (!this.datum.salary) {
                this.datum.salary = {
                  min: null,
                  max: null
                }
              }

              if (!this.datum.age) {
                this.datum.age = {
                  min: null,
                  max: null
                }
              }

              if (!datum.steps || !Array.isArray(datum.steps)) {
                this.datum.steps = [{ code: '10' }, { code: '50' }]
              } else {
                this.datum.steps = []
                datum.steps.forEach((step) => {
                  this.datum.steps.push({ code: step })
                })
              }

              if (!this.datum.locations || !Array.isArray(this.datum.locations)) {
                this.datum.locations = [{
                  prefecture: null,
                  name: null
                }]
              }

              if (this.datum.Managers) {
                this.selected.managers = clone(this.datum.Managers)
                // this.options.manager = this.selected.managers
                delete this.datum.Managers
              }

              if (this.datum.Recruiters) {
                this.selected.recruiters = clone(this.datum.Recruiters)
                // this.options.recruiter = this.selected.recruiters
                delete this.datum.Recruiters
              }

              if (this.datum.Staffs) {
                this.selected.staffs = clone(this.datum.Staffs)
                // this.options.staffs = this.selected.staffs
                delete this.datum.Staffs
              }

              if (this.datum.Agents) {
                this.selected.agents = clone(this.datum.Agents)
                // this.options.agent = this.selected.agents
                delete this.datum.Agents
              }

              if (this.datum.Consultants) {
                this.selected.consultants = clone(this.datum.Consultants)
                // this.options.consultant = this.selected.consultants
                delete this.datum.Consultants
              }

              this.validateInput()

              this.recentDatum = clone(this.datum)
              this.recentDatum.managers = clone(this.selected.managers)
              this.recentDatum.recruiters = clone(this.selected.recruiters)
              this.recentDatum.staffs = clone(this.selected.staffs)
              this.recentDatum.agents = clone(this.selected.agents)
              this.recentDatum.consultants = clone(this.selected.consultants)

              this.changed = false
              this.valid = false
            } else {
              message = 'Not Found Data'
            }
          }).catch((err) => {
            console.log(err)

            message = 'データの読込に失敗しました'

            if (err.response.data) {
              if (err.response.data.code && err.response.data.message) {
                message = err.response.data.message
              } else if (err.response.data.message) {
                message = err.response.data.message
              }
            }
          })
        }

        this.changed = false

        this.$nextTick(() => {
          this.$refs.observer.reset()
        })
      } else if (this.$route.params.id) {
        if (!this.currentUser.acl || !this.currentUser.acl.jobs || !this.currentUser.acl.jobs.get) {
          this.handleLink(`/${this.$route.params.directory}/jobs`)
        }

        if (this.currentUser.acl && this.currentUser.acl.jobs && this.currentUser.acl.jobs.patch) {
          this.editable = true
          this.mode = 'edit'
        }

        await getData(`/jobs/${this.$route.params.id}`).then((datum) => {
          if (datum) {
            this.datum = clone(datum)

            if (!this.datum.salary) {
              this.datum.salary = {
                min: null,
                max: null
              }
            }

            if (!this.datum.age) {
              this.datum.age = {
                min: null,
                max: null
              }
            }

            if (!datum.steps || !Array.isArray(datum.steps)) {
              this.datum.steps = [{ code: '10' }, { code: '50' }]
            } else {
              this.datum.steps = []
              datum.steps.forEach((step) => {
                this.datum.steps.push({ code: step })
              })
            }

            if (!this.datum.locations || !Array.isArray(this.datum.locations)) {
              this.datum.locations = [{
                prefecture: null,
                name: null
              }]
            }

            if (this.datum.Managers) {
              this.selected.managers = clone(this.datum.Managers)
              // this.options.manager = this.selected.managers
              delete this.datum.Managers
            }

            if (this.datum.Recruiters) {
              this.selected.recruiters = clone(this.datum.Recruiters)
              // this.options.recruiter = this.selected.recruiters
              delete this.datum.Recruiters
            }

            if (this.datum.Staffs) {
              this.selected.staffs = clone(this.datum.Staffs)
              // this.options.staffs = this.selected.staffs
              delete this.datum.Staffs
            }

            if (this.datum.Agents) {
              this.selected.agents = clone(this.datum.Agents)
              // this.options.agent = this.selected.agents
              delete this.datum.Agents
            }

            if (this.datum.Consultants) {
              this.selected.consultants = clone(this.datum.Consultants)
              // this.options.consultant = this.selected.consultants
              delete this.datum.Consultants
            }

            if (!this.datum.links || !Array.isArray(this.datum.links) || this.datum.links.length === 0) {
              this.datum.links = []
            }

            this.validateInput()

            this.recentDatum = clone(this.datum)
            this.recentDatum.managers = clone(this.selected.managers)
            this.recentDatum.recruiters = clone(this.selected.recruiters)
            this.recentDatum.staffs = clone(this.selected.staffs)
            this.recentDatum.agents = clone(this.selected.agents)
            this.recentDatum.consultants = clone(this.selected.consultants)

            this.changed = false
            this.valid = false
          } else {
            message = 'Not Found Data'
          }
        }).catch((err) => {
          console.log(err)

          message = 'データの読込に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
        this.handleLink(`/${this.$route.params.directory}/jobs`)
      }

      let options = []

      if (this.options.manager.length > 0 && this.selected.managers.length > 0) {
        options = this.options.manager.filter((optionsUser) => {
          let findUser = this.selected.managers.find((selectedUser) => {
            return String(optionsUser._id) === String(selectedUser._id)
          })
          return !findUser
        })
        this.options.manager = clone(options)
      }

      if (this.options.recruiter.length > 0 && this.selected.recruiters.length > 0) {
        options = this.options.recruiter.filter((optionsUser) => {
          let findUser = this.selected.recruiters.find((selectedUser) => {
            return String(optionsUser._id) === String(selectedUser._id)
          })
          return !findUser
        })
        this.options.recruiter = clone(options)
      }

      if (this.options.staff.length > 0 && this.selected.staffs.length > 0) {
        options = this.options.staff.filter((optionsUser) => {
          let findUser = this.selected.staffs.find((selectedUser) => {
            return String(optionsUser._id) === String(selectedUser._id)
          })
          return !findUser
        })
        this.options.staff = clone(options)
      }

      if (this.options.agent.length > 0 && this.selected.agents.length > 0) {
        options = this.options.agent.filter((optionsUser) => {
          let findUser = this.selected.agents.find((selectedUser) => {
            return String(optionsUser._id) === String(selectedUser._id)
          })
          return !findUser
        })
        this.options.agent = clone(options)
      }

      if (this.options.consultant.length > 0 && this.selected.consultants.length > 0) {
        options = this.options.consultant.filter((optionsUser) => {
          let findUser = this.selected.consultants.find((selectedUser) => {
            return String(optionsUser._id) === String(selectedUser._id)
          })
          return !findUser
        })
        this.options.consultant = clone(options)
      }

      this.$forceUpdate()

      this.$nextTick(() => {
        this.$refs.observer.reset()
      })
    },
    onManagerSearch (search, loading) {
      this.onOptionSearch('manager', search, loading)
    },
    onRecruiterSearch (search, loading) {
      this.onOptionSearch('recruiter', search, loading)
    },
    onStaffSearch (search, loading) {
      this.onOptionSearch('staff', search, loading)
    },
    onAgentSearch (search, loading) {
      this.onOptionSearch('agent', search, loading)
    },
    onConsultantSearch (search, loading) {
      this.onOptionSearch('consultant', search, loading)
    },
    async onOptionSearch (field, search, loading) {
      const that = this
      loading(true)

      let roles
      let selectedUsers

      if (field === 'manager') {
        roles = ['master', 'manager']
        selectedUsers = clone(this.selected.managers)
      } else if (field === 'recruiter') {
        roles = ['master', 'manager', 'recruiter']
        selectedUsers = clone(this.selected.recruiters)
      } else if (field === 'staff') {
        roles = ['master', 'manager', 'recruiter', 'staff']
        selectedUsers = clone(this.selected.staffs)
      } else if (field === 'agent') {
        roles = ['agent']
        selectedUsers = clone(this.selected.agents)
      } else if (field === 'consultant') {
        roles = ['consultant']
        selectedUsers = clone(this.selected.consultants)
      }

      let query = new QueryHash()
      let filters = []
      if (search) {
        filters.push({
          $or: [
            { name: `RegExp:('${search}')` },
            { email: `RegExp:('${search}')` }
          ]
        })
      }
      filters.push({
        role: {
          $in: roles
        }
      })

      let selectedIds = []

      if (selectedUsers && selectedUsers.length > 0) {
        selectedUsers.forEach((selectedUser) => {
          selectedIds.push(`ObjectId:('${selectedUser._id}')`)
        })
        if (selectedIds.length > 0) {
          filters.push({ _id: { $nin: selectedIds } })
        }
      }

      query.add('filter', JSON.stringify({ $and: filters }))

      query.add('fields', '_id,name')

      await getData(`/users?${query.toQueryString()}`).then((data) => {
        that.$data.options[field] = data
        loading(false)
      })
    },
    onClose () {
      if (this.mode === 'show') {
        this.doClose()
      } else if (this.mode === 'edit') {
        if (!this.changed) {
          this.doClose()
        } else {
          this.msgBoxConfirm('内容が変更されています。変更を破棄しますか？', () => {
            this.doClose()
          })
        }
      } else if (this.mode === 'add') {
        if (!this.changed) {
          this.doClose()
        } else {
          this.msgBoxConfirm('内容が変更されています。変更を破棄しますか？', () => {
            this.doClose()
          })
        }
      }
    },
    doClose () {
      this.handleLink(`/${this.$route.params.directory}/jobs`)
    },
    addSteps () {
      this.datum.steps.push({ code: null })
      this.validateInput()
      this.$forceUpdate()
    },
    removeSteps (index) {
      this.datum.steps.splice(index, 1)
      this.validateInput()
      this.$forceUpdate()
    },
    addLocations () {
      this.datum.locations.push({
        prefecture: null,
        name: null
      })
      this.validateInput()
      this.$forceUpdate()
    },
    removeLocations (index) {
      this.datum.locations.splice(index, 1)
      this.validateInput()
      this.$forceUpdate()
    },
    addLinks () {
      this.datum.links.push({
        caption: '',
        url: ''
      })
      this.validateInput()
      this.$forceUpdate()
    },
    removeLinks (index) {
      this.datum.links.splice(index, 1)
      this.validateInput()
      this.$forceUpdate()
    },
    removeUploadFile (index) {
      this.uploadFiles.splice(index, 1)
      this.validateInput()
      this.$forceUpdate()
    },
    removeFile (index) {
      if (this.datum.Files[index].remove) {
        this.datum.Files[index].remove = false
      } else {
        this.datum.Files[index].remove = true
      }
      this.validateInput()
      this.$forceUpdate()
    },
    onCopy () {
      this.msgBoxConfirm('内容をコピーします。よろしいですか？', () => {
        this.doCopy()
      })
    },
    doCopy () {
      this.handleLink(`/${this.$route.params.directory}/job/?copy=${this.id}`)
      this.mode = 'add'
      this.editable = true
      this.loadData()
    },
    async onSave () {
      this.valid = await this.$refs.observer.validate()
      if (!this.valid) {
        this.msgBoxError('Invalid Inputs')
      } else {
        this.msgBoxConfirm('ポジション情報を保存しますか？', this.doSave)
      }
    },
    async doSave () {
      this.mask = true

      let datum = clone(this.datum)

      if (typeof datum.enable === 'string') {
        if (datum.enable === 'true') {
          datum.enable = true
        } else {
          datum.enable = false
        }
      }

      if (datum.launchDate) {
        datum.launchDate = dayjs(datum.launchDate).format('YYYY-MM-DD')
      }
      if (datum.dueDate) {
        datum.dueDate = dayjs(datum.dueDate).format('YYYY-MM-DD')
      }

      datum.steps = []
      if (this.datum.steps && this.datum.steps.length > 0) {
        this.datum.steps.forEach((step) => {
          datum.steps.push(step.code)
        })
      }

      delete datum.Managers
      datum.managers = []
      if (this.selected.managers && this.selected.managers.length > 0) {
        this.selected.managers.forEach((manager) => {
          datum.managers.push(manager._id)
        })
      }
      delete datum.Recruiters
      datum.recruiters = []
      if (this.selected.recruiters && this.selected.recruiters.length > 0) {
        this.selected.recruiters.forEach((recruiter) => {
          datum.recruiters.push(recruiter._id)
        })
      }
      delete datum.Staffs
      datum.staffs = []
      if (this.selected.staffs && this.selected.staffs.length > 0) {
        this.selected.staffs.forEach((staff) => {
          datum.staffs.push(staff._id)
        })
      }
      delete datum.Agents
      datum.agents = []
      if (this.selected.agents && this.selected.agents.length > 0) {
        this.selected.agents.forEach((agent) => {
          datum.agents.push(agent._id)
        })
      }
      delete datum.Consultants
      datum.consultants = []
      if (this.selected.consultants && this.selected.consultants.length > 0) {
        this.selected.consultants.forEach((consultant) => {
          datum.consultants.push(consultant._id)
        })
      }

      delete datum.postedAt
      delete datum.PostedBy
      delete datum.patchedAt
      delete datum.PatchedBy

      let message = null

      if (this.mode === 'add') {
        await postData(`/jobs/`, datum).then(async (json) => {
          // this.datum._id = json._id
          if (this.uploadFiles.length) {
            await this.doUploadFiles()
          }
          this.handleLink(`/${this.$route.params.directory}/jobs`)
        }).catch((err) => {
          console.log(err)

          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } else {
        await patchData(`/jobs/${datum._id}`, datum).then(async (json) => {
          this.handleLink(`/${this.$route.params.directory}/jobs`)
        }).catch((err) => {
          console.log(err)

          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })

        if (!message || (message && message === 'Not Changed Data')) {
          if (this.uploadFiles.length > 0) {
            message = await this.doUploadFiles()
          }
        }

        if (!message || (message && message === 'Not Changed Data')) {
          if (this.datum.Files) {
            const isRemoveFile = this.datum.Files.find((file) => {
              return file.remove
            })
            if (isRemoveFile) {
              message = await this.doRemoveFiles()
            }
          }
        }
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      }
    },
    onDelete () {
      if (!this.currentUser.acl || !this.currentUser.acl.jobs || !this.currentUser.acl.jobs.delete) {
        return
      }

      this.msgBoxConfirm('ポジション情報を削除しますか？', this.doDelete)
    },
    async doDelete () {
      this.mask = true

      let message = ''

      await deleteData(`/jobs/${this.datum._id}`).then((json) => {
        this.handleLink(`/${this.$route.params.directory}/jobs`)
      }).catch((err) => {
        console.log(err)

        message = 'データの削除に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }
      })

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      }
    },
    async doUploadFiles () {
      if (!this.uploadFiles || this.uploadFiles.length === 0) { return }

      let message = null

      for (let uploadFile of this.uploadFiles) {
        let formData = new FormData()
        formData.append(`uploadFile`, uploadFile)

        await postFiles(`/jobs/${this.datum._id}/upload`, formData).then((json) => {
        }).catch((err) => {
          console.log(err)

          message = '添付ファイルのアップロードに失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })

        if (message) { break }
      }

      return message
    },
    async doRemoveFiles () {
      if (!this.datum.Files.length || this.datum.Files.length === 0) { return }

      let message = null

      for (let file of this.datum.Files) {
        if (file.remove) {
          await deleteData(`/jobs/${this.datum._id}/files/${file._id}.${file.extension}`).then((json) => {
          }).catch((err) => {
            console.log(err)

            message = '添付ファイルの削除に失敗しました'

            if (err.response.data) {
              if (err.response.data.code && err.response.data.message) {
                message = err.response.data.message
              } else if (err.response.data.message) {
                message = err.response.data.message
              }
            }
          })

          if (message) { break }
        }
      }

      return message
    }
  }
}
</script>

<style scoped lang="stylus">
.body
  .form
    overflow-y scroll
    overflow-x hidden
    height calc(100vh - 3.75rem - 5.5rem - 4.75rem)

.input-step-codes
  min-width 10rem
.input-location-names
  min-width 20rem
.recruitments
  input
    max-width 12rem
.dueDate
.launchDate
  input
    max-width 12rem
.salary
.age
  .form-inline
    align-items flex-start
    .separator
      padding-top 1rem
    input
      max-width 8rem
      border-top-right-radius 8px
      border-bottom-right-radius 8px
    .input-group-append
      border 0 none
      color #343a40
      font-size 0.875rem
      height 3rem
      padding-top 0.75rem
      padding-left 0.3rem
.steps
  .box
    display inline-block
    vertical-align top
    .form-control-feedback
      display block
      margin-left 1rem
      overflow hidden
.addSteps
.removeSteps
  i
    font-size 1.5rem
.addSteps
  padding 0.5rem 1rem 1.5rem 1rem
.removeSteps
  padding 0.5rem 1rem
  &.disabled
    display none
.addSteps i
  color #156eff
.removeSteps i
  color #999

.locations
  .box
    display inline-block
    vertical-align top
    .form-control-feedback
      display block
      margin-left 1rem
      overflow hidden
.addLocations
.removeLocations
  i
    font-size 1.5rem
.addLocations
  padding 0.5rem 1rem 1.5rem 1rem
.removeLocations
  padding 0.5rem 1rem
  &.disabled
    display none
.addLocations i
  color #156eff
.removeLocations i
  color #999

.links
  .card
    .card-title
      width 100%
      display flex
      justify-content flex-end
      margin-top 0.5rem
      margin-right 0.5rem
      // z-index 1001
    .card-body
      // z-index 1000
.addLinks
.removeLinks
  z-index 1000
  i
    font-size 1.5rem
.addLinks
  padding 0.5rem 1rem 1.5rem 1rem
  i
    color #156eff
.removeLinks
  padding 0.5rem 1rem
  i
    color #999
  &.disabled
    display none

.border.rounded
  min-height 3rem

.files
  .file
    display inline-block
    word-break break-all
    .removeFiles
      i
        font-size 1.5rem
        color #999
      padding 0 1rem 0 0.5rem
      &.disabled
        display none
    &.remove
      a, button
        color red
        text-decoration line-through solid
</style>
